import { render } from "./BlockText.vue?vue&type=template&id=d5e26636"
import script from "./BlockText.vue?vue&type=script&lang=js"
export * from "./BlockText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/BlockEditors/BlockText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5e26636"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5e26636', __exports__)) {
    console.log('reload')
    api.reload('d5e26636', __exports__)
  }
  
  module.hot.accept("./BlockText.vue?vue&type=template&id=d5e26636", () => {
    console.log('re-render')
    api.rerender('d5e26636', render)
  })

}


export default __exports__